// extracted by mini-css-extract-plugin
module.exports = {"shippingInfoContainer":"styles_shippingInfoContainer__Zo_7r","inputContainer":"styles_inputContainer__1KQMX","shippingInfo":"styles_shippingInfo__2VHxT"};